import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useLocation } from "react-router-dom";

import { HeroDefault } from '../components/default-sections/Hero';
import CodeEditor from "../components/main/CodeEditor";

import SnippetCard from '../components/main/SnippetMenu';
import { auth } from "../auth/firebase/Firebase";
import { fetchUserName, getSnippetById } from "../auth/firebase/snippets/Controller";
import { snippetImg } from "../assets/const/Images";
import "../assets/css/CreateSnippet.css"

function SingleSnippet() {
    const location = useLocation();
    const [user, loading] = useAuthState(auth);
    const [name, setName] = useState("");
    const [snippet, setSnippet] = useState(null);

    useEffect(() => {
        if (loading) return;
        const getSnippetContent = () => {
            if (location.pathname && location.pathname.includes("/snippet/")) {
                let path = location.pathname;
                let parts = path.split("/");
                let snippetId = parts[2];
                getSnippetById(snippetId)
                    .then((data) => {
                        setSnippet(data);
                    })
            }
        }
        //user not yet loaded
        if (!name) {
            fetchUserName(user)
                .then((name) => {
                    setName(name);
                })
        }
        //snippet not yet loaded
        if(!snippet)
            getSnippetContent();
    }, [loading, location, name, user, snippet]);

    const loadSnippetContent = () => {
        const date = new Date(snippet.createdAt);
        const createdAt = date.toLocaleDateString();

        return (
            <>
                <div className="row gx-5">
                    <div className="col-lg-8 col-xl-9">
                        <div className="card mb-3">
                            <div className="snippet-card-body">
                                <div className="snippet-card-body-content">
                                    {_getSnippetValue("Description", snippet.description)}
                                    {_getSnippetValue("How it works", snippet.howitworks)}
                                    <div className="code-editor">
                                        <CodeEditor
                                            code={snippet.code}
                                            theme={"cobalt"}
                                            language={snippet.language}

                                        />
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className="post-preview-meta">
                                        <img className="post-preview-meta-img" src={snippetImg.usericon} alt="..." />
                                        <div className="post-preview-meta-details">
                                            <div className="post-preview-meta-details-name">{snippet.createdBy}</div>
                                            <div className="post-preview-meta-details-date">{createdAt}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {_getCommentSection( false )}
                    </div>
                    <div className="col-lg-4 col-xl-3 mb-5">
                        <div className="card">
                            <div className="list-group list-group-flush small">
                                <div className="list-group-item list-group-item-action p-3">
                                    <h3>Language</h3>
                                    <p className="lead">{snippet.language}</p>
                                </div>
                                {snippet.tags.length > 0 ? (                                   
                                        <div className="list-group-item list-group-item-action p-3">
                                            {
                                                snippet.tags.map((t,i) =>
                                                    <span className="badge text-bg-info tag-spacing" key={i}>{t}</span>
                                                )
                                            }
                                        </div>
                                ) : ("")}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const _getCommentSection = ( active ) => {
        if ( !active ) return;
        return (
            <>
                <div className="card z-1">
                    <div className="card-body text-center py-5">
                        <h2 className="mb-3">We're here to help</h2>
                        <a className="btn btn-primary fw-500" href="#!">Open a New Ticket</a>
                    </div>
                </div>
            </>
        )
    }

    const _getSnippetValue = (heading, value) => {
        if (!value) return;
        return (
            <>
                <h4 className="mb-3">{heading}</h4>
                <p className="card-text">{value}</p>
            </>
        )
    }

    return (
        (snippet !== null ? (
            <>
                <HeroDefault
                    header={snippet.title}
                    content={loadSnippetContent()}
                />
                <SnippetCard user={user} />
            </>
        ) : (""))
    );
}
export default SingleSnippet;


